var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sos-marker"},[_c('span',{staticClass:"sos-marker__ping"}),_c('span',{staticClass:"sos-marker__badge"},[_vm._v("SOS")])])
}]

export { render, staticRenderFns }